import { Injectable } from '@angular/core'
import SparkMD5 from 'spark-md5'

const CHUNK_SIZE = 256 * 1024

export interface HashProgress {
  loaded: number
  total: number
  pct: number
}

export interface HashResult {
  hash: string
}

@Injectable({ providedIn: 'root' })
export class FileHashService {
  async hash(file: File, onProgress?: (p: HashProgress) => void): Promise<string> {
    const spark = new SparkMD5.ArrayBuffer()
    const total = file.size
    let offset = 0
    while (offset < total) {
      const end = Math.min(offset + CHUNK_SIZE, total)
      const buffer = await file.slice(offset, end).arrayBuffer()
      spark.append(buffer)
      offset = end
      if (onProgress) {
        onProgress({ loaded: offset, total, pct: total > 0 ? (offset / total) * 100 : 100 })
      }
      await new Promise(resolve => setTimeout(resolve, 0))
    }
    return spark.end()
  }
}
